import React from 'react';
import { Link } from 'react-router-dom';
import { BarChartIcon, ClipboardListIcon, CalendarIcon, ClockIcon, PlusIcon, UploadIcon, FileTextIcon, ArrowUpIcon, ArrowDownIcon, ChevronRightIcon, MessageSquareIcon, DollarSignIcon, UserIcon, HomeIcon } from 'lucide-react';
export function Dashboard() {
  return <div className="space-y-4" data-id="element-1443">
      <div className="flex items-center justify-between" data-id="element-1444">
        <h1 className="text-2xl font-bold text-neutral-900" data-id="element-1445">Dashboard</h1>
      </div>
      {/* KPI Metrics */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4" data-id="element-1446">
        <div className="card p-4" data-id="element-1447">
          <div className="flex items-center justify-between" data-id="element-1448">
            <h3 className="text-sm font-medium text-neutral-500" data-id="element-1449">
              Leads This Month
            </h3>
            <span className="badge badge-primary text-sm" data-id="element-1450">+12%</span>
          </div>
          <div className="mt-2 flex items-baseline" data-id="element-1451">
            <p className="text-3xl font-semibold text-neutral-900" data-id="element-1452">24</p>
            <p className="ml-2 text-sm text-neutral-500" data-id="element-1453">/ 30 goal</p>
          </div>
          <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-neutral-200" data-id="element-1454">
            <div className="h-full rounded-full bg-primary-500" style={{
            width: '80%'
          }} data-id="element-1455"></div>
          </div>
        </div>
        <div className="card p-4" data-id="element-1456">
          <div className="flex items-center justify-between" data-id="element-1457">
            <h3 className="text-sm font-medium text-neutral-500" data-id="element-1458">
              Pre-Approvals
            </h3>
            <span className="badge badge-success text-sm" data-id="element-1459">+8%</span>
          </div>
          <div className="mt-2 flex items-baseline" data-id="element-1460">
            <p className="text-3xl font-semibold text-neutral-900" data-id="element-1461">18</p>
            <span className="ml-2 flex items-center text-sm text-success-600" data-id="element-1462">
              <ArrowUpIcon className="mr-1 h-3 w-3" data-id="element-1463" />3
            </span>
          </div>
          <div className="mt-3 text-sm text-neutral-500" data-id="element-1464">
            75% conversion rate
          </div>
        </div>
        <div className="card p-4" data-id="element-1465">
          <div className="flex items-center justify-between" data-id="element-1466">
            <h3 className="text-sm font-medium text-neutral-500" data-id="element-1467">Live Deals</h3>
          </div>
          <div className="mt-2 flex items-baseline" data-id="element-1468">
            <p className="text-3xl font-semibold text-neutral-900" data-id="element-1469">12</p>
          </div>
          <div className="mt-3 text-sm text-neutral-500" data-id="element-1470">$4.2M total value</div>
        </div>
        <div className="card p-4" data-id="element-1471">
          <div className="flex items-center justify-between" data-id="element-1472">
            <h3 className="text-sm font-medium text-neutral-500" data-id="element-1473">
              Approvals Pending
            </h3>
            <span className="badge badge-warning text-sm" data-id="element-1474">3 urgent</span>
          </div>
          <div className="mt-2 flex items-baseline" data-id="element-1475">
            <p className="text-3xl font-semibold text-neutral-900" data-id="element-1476">7</p>
          </div>
          <div className="mt-3 text-sm text-neutral-500" data-id="element-1477">
            2 expiring this week
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3" data-id="element-1478">
        {/* Pipeline Summary */}
        <div className="col-span-2 card p-4" data-id="element-1479">
          <div className="flex items-center justify-between" data-id="element-1480">
            <h2 className="text-lg font-medium text-neutral-900" data-id="element-1481">
              Deal Pipeline
            </h2>
            <Link to="/deals/kanban" className="text-sm font-medium text-primary-600 hover:text-primary-500" data-id="element-1482">
              View all
            </Link>
          </div>
          <div className="mt-3 overflow-x-auto" data-id="element-1483">
            <div className="flex space-x-3 min-w-max" data-id="element-1484">
              <div className="flex-1 min-w-[150px]" data-id="element-1485">
                <div className="mb-2 flex items-center justify-between" data-id="element-1486">
                  <h3 className="text-sm font-medium text-neutral-700" data-id="element-1487">Lead</h3>
                  <span className="rounded-full bg-neutral-100 px-2 py-0.5 text-sm font-medium text-neutral-800" data-id="element-1488">
                    8
                  </span>
                </div>
                <div className="space-y-3" data-id="element-1489">
                  <Link to="/leads/1001" className="block rounded-md border border-neutral-200 bg-white p-3 shadow-sm hover:bg-neutral-50" data-id="element-1490">
                    <div className="text-sm font-medium text-neutral-900" data-id="element-1491">
                      Sarah Strauss
                    </div>
                    <div className="mt-1 text-sm text-neutral-500" data-id="element-1492">
                      Added 2 days ago
                    </div>
                  </Link>
                  <Link to="/leads/1002" className="block rounded-md border border-neutral-200 bg-white p-3 shadow-sm hover:bg-neutral-50" data-id="element-1493">
                    <div className="text-sm font-medium text-neutral-900" data-id="element-1494">
                      Michael Bray
                    </div>
                    <div className="mt-1 text-sm text-neutral-500" data-id="element-1495">
                      Added 3 days ago
                    </div>
                  </Link>
                  <Link to="/leads/1003" className="block rounded-md border border-neutral-200 bg-white p-3 shadow-sm hover:bg-neutral-50" data-id="element-1496">
                    <div className="text-sm font-medium text-neutral-900" data-id="element-1497">
                      James Wilson
                    </div>
                    <div className="mt-1 text-sm text-neutral-500" data-id="element-1498">
                      Added 5 days ago
                    </div>
                  </Link>
                </div>
              </div>
              <div className="flex-1 min-w-[150px]" data-id="element-1499">
                <div className="mb-2 flex items-center justify-between" data-id="element-1500">
                  <h3 className="text-sm font-medium text-neutral-700" data-id="element-1501">
                    Pre-Approval
                  </h3>
                  <span className="rounded-full bg-neutral-100 px-2 py-0.5 text-sm font-medium text-neutral-800" data-id="element-1502">
                    5
                  </span>
                </div>
                <div className="space-y-3" data-id="element-1503">
                  <Link to="/leads/1004" className="block rounded-md border border-neutral-200 bg-white p-3 shadow-sm hover:bg-neutral-50" data-id="element-1504">
                    <div className="text-sm font-medium text-neutral-900" data-id="element-1505">
                      Emily Johnson
                    </div>
                    <div className="mt-1 text-sm text-neutral-500" data-id="element-1506">
                      $450,000 max
                    </div>
                  </Link>
                  <Link to="/leads/1005" className="block rounded-md border border-neutral-200 bg-white p-3 shadow-sm hover:bg-neutral-50" data-id="element-1507">
                    <div className="text-sm font-medium text-neutral-900" data-id="element-1508">
                      David Chen
                    </div>
                    <div className="mt-1 text-sm text-neutral-500" data-id="element-1509">
                      $380,000 max
                    </div>
                  </Link>
                </div>
              </div>
              <div className="flex-1 min-w-[150px]" data-id="element-1510">
                <div className="mb-2 flex items-center justify-between" data-id="element-1511">
                  <h3 className="text-sm font-medium text-neutral-700" data-id="element-1512">
                    Live Deal
                  </h3>
                  <span className="rounded-full bg-neutral-100 px-2 py-0.5 text-sm font-medium text-neutral-800" data-id="element-1513">
                    4
                  </span>
                </div>
                <div className="space-y-3" data-id="element-1514">
                  <Link to="/deals/1001" className="block rounded-md border border-neutral-200 bg-white p-3 shadow-sm hover:bg-neutral-50" data-id="element-1515">
                    <div className="text-sm font-medium text-neutral-900" data-id="element-1516">
                      Robert & Lisa Taylor
                    </div>
                    <div className="mt-1 text-sm text-neutral-500" data-id="element-1517">
                      123 Main St - $425,000
                    </div>
                  </Link>
                </div>
              </div>
              <div className="flex-1 min-w-[150px]" data-id="element-1518">
                <div className="mb-2 flex items-center justify-between" data-id="element-1519">
                  <h3 className="text-sm font-medium text-neutral-700" data-id="element-1520">
                    Approved
                  </h3>
                  <span className="rounded-full bg-neutral-100 px-2 py-0.5 text-sm font-medium text-neutral-800" data-id="element-1521">
                    2
                  </span>
                </div>
                <div className="space-y-3" data-id="element-1522">
                  <Link to="/deals/1002" className="block rounded-md border border-neutral-200 bg-white p-3 shadow-sm hover:bg-neutral-50" data-id="element-1523">
                    <div className="text-sm font-medium text-neutral-900" data-id="element-1524">
                      Jennifer Smith
                    </div>
                    <div className="mt-1 text-sm text-neutral-500" data-id="element-1525">
                      Closing Sept 15
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Activity & Tasks */}
        <div className="card p-4" data-id="element-1526">
          <div className="flex items-center justify-between" data-id="element-1527">
            <h2 className="text-lg font-medium text-neutral-900" data-id="element-1528">Tasks Due</h2>
            <Link to="/leads" className="text-sm font-medium text-primary-600 hover:text-primary-500" data-id="element-1529">
              View all
            </Link>
          </div>
          <div className="mt-3 space-y-3" data-id="element-1530">
            <div className="flex items-start" data-id="element-1531">
              <input type="checkbox" className="mt-1 h-4 w-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500" data-id="element-1532" />
              <div className="ml-3" data-id="element-1533">
                <p className="text-sm font-medium text-neutral-900" data-id="element-1534">
                  Follow up with Sarah Strauss
                </p>
                <p className="text-sm text-neutral-500" data-id="element-1535">Due today at 3:00 PM</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1536">
              <input type="checkbox" className="mt-1 h-4 w-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500" data-id="element-1537" />
              <div className="ml-3" data-id="element-1538">
                <p className="text-sm font-medium text-neutral-900" data-id="element-1539">
                  Request income documents - Michael Bray
                </p>
                <p className="text-sm text-neutral-500" data-id="element-1540">Due tomorrow</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1541">
              <input type="checkbox" className="mt-1 h-4 w-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500" data-id="element-1542" />
              <div className="ml-3" data-id="element-1543">
                <p className="text-sm font-medium text-neutral-900" data-id="element-1544">
                  Submit Taylor application to lender
                </p>
                <p className="text-sm text-neutral-500" data-id="element-1545">Due Sep 12</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1546">
              <input type="checkbox" className="mt-1 h-4 w-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500" data-id="element-1547" />
              <div className="ml-3" data-id="element-1548">
                <p className="text-sm font-medium text-neutral-900" data-id="element-1549">
                  Prepare signing package for Smith
                </p>
                <p className="text-sm text-neutral-500" data-id="element-1550">Due Sep 14</p>
              </div>
            </div>
          </div>
          <div className="mt-4 border-t border-neutral-200 pt-3" data-id="element-1551">
            <h3 className="text-sm font-medium text-neutral-900" data-id="element-1552">
              Upcoming Renewals
            </h3>
            <div className="mt-3 space-y-3" data-id="element-1553">
              <div className="flex items-center justify-between" data-id="element-1554">
                <div data-id="element-1555">
                  <p className="text-sm font-medium text-neutral-900" data-id="element-1556">
                    Johnson Residence
                  </p>
                  <p className="text-sm text-neutral-500" data-id="element-1557">Due in 30 days</p>
                </div>
                <Link to="/renewals/1" className="text-sm text-primary-600 hover:text-primary-500" data-id="element-1558">
                  <ChevronRightIcon className="h-5 w-5" data-id="element-1559" />
                </Link>
              </div>
              <div className="flex items-center justify-between" data-id="element-1560">
                <div data-id="element-1561">
                  <p className="text-sm font-medium text-neutral-900" data-id="element-1562">
                    Williams Property
                  </p>
                  <p className="text-sm text-neutral-500" data-id="element-1563">Due in 45 days</p>
                </div>
                <Link to="/renewals/2" className="text-sm text-primary-600 hover:text-primary-500" data-id="element-1564">
                  <ChevronRightIcon className="h-5 w-5" data-id="element-1565" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Additional Metrics */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-1566">
        <div className="card p-4" data-id="element-1567">
          <div className="flex items-center" data-id="element-1568">
            <div className="mr-4 rounded-full bg-primary-100 p-3 text-primary-600" data-id="element-1569">
              <MessageSquareIcon className="h-5 w-5" data-id="element-1570" />
            </div>
            <div data-id="element-1571">
              <h3 className="text-sm font-medium text-neutral-500" data-id="element-1572">
                Unread Messages
              </h3>
              <p className="text-xl font-semibold text-neutral-900" data-id="element-1573">8</p>
            </div>
          </div>
          <div className="mt-3 text-right" data-id="element-1574">
            <Link to="/inbox" className="text-sm font-medium text-primary-600 hover:text-primary-500" data-id="element-1575">
              View inbox
            </Link>
          </div>
        </div>
        <div className="card p-4" data-id="element-1576">
          <div className="flex items-center" data-id="element-1577">
            <div className="mr-4 rounded-full bg-primary-100 p-3 text-primary-600" data-id="element-1578">
              <ClockIcon className="h-5 w-5" data-id="element-1579" />
            </div>
            <div data-id="element-1580">
              <h3 className="text-sm font-medium text-neutral-500" data-id="element-1581">
                Time Logged This Week
              </h3>
              <p className="text-xl font-semibold text-neutral-900" data-id="element-1582">24.5 hrs</p>
            </div>
          </div>
          <div className="mt-3 text-right" data-id="element-1583">
            <Link to="/reports" className="text-sm font-medium text-primary-600 hover:text-primary-500" data-id="element-1584">
              View details
            </Link>
          </div>
        </div>
        <div className="card p-4" data-id="element-1585">
          <div className="flex items-center" data-id="element-1586">
            <div className="mr-4 rounded-full bg-primary-100 p-3 text-primary-600" data-id="element-1587">
              <DollarSignIcon className="h-5 w-5" data-id="element-1588" />
            </div>
            <div data-id="element-1589">
              <h3 className="text-sm font-medium text-neutral-500" data-id="element-1590">
                Commission Forecast
              </h3>
              <p className="text-xl font-semibold text-neutral-900" data-id="element-1591">$32,450</p>
            </div>
          </div>
          <div className="mt-3 text-right" data-id="element-1592">
            <Link to="/reports" className="text-sm font-medium text-primary-600 hover:text-primary-500" data-id="element-1593">
              View forecast
            </Link>
          </div>
        </div>
      </div>
    </div>;
}